import _ from 'lodash';
import ServerError from './common/ServerError';
import Button from './common/Button';
import CheckBox from './common/CheckBox';
import Select from './common/Select';
import TaskTable from './common/TaskTable';
import EventForm, { validateField } from './common/EventForm';
import EventStream from './common/EventStream';
import IntakeForm from './IntakeForm';
import PaymentForm, {DEFAULT_BILLABLE_MINUTE_INCREMENTS} from './PaymentForm';
import TemplatesForm from './TemplatesForm';
import TextEditor from './common/TextEditor';
import { getNewId, validateTaskField } from './common/TaskEditor';
import TaskEditorField, { getDefaultField } from './common/TaskEditorField';
import ConfirmDialog from './common/ConfirmDialog';
import EmailDialog from './common/EmailDialog';
import ClientAvatar from './common/ClientAvatar';
import { isEmptyObject, isEmptyString } from '../validators/formValidators';
import { validateNotesForm } from '../validators/notesFormValidator';
import { matterPartialFormSavePromise,
         getFullName,
         getWorkflowTranslationHashTable,
         transformTextFromPlaceholderMapping,
         filteredRoute,
         filterTasks,
         findBootstrapEnvironment, 
         updateTask,
         isDemoAccount, 
         getAssignedToFullName} from '../helpers/utils';

import { getCaseStateColor, requiredFormFieldColor } from '../helpers/colors';

import { caseSetServerError,
         casesAllAction,
         caseNewAction,
         caseEditIdAction,
         caseDeleteAction,
         caseEditEvent,
         caseGetChargesAction } from '../actions/caseActions';

import { userLogInLoadAction } from '../actions/userActions';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { Row, Col, Panel, Form, Nav, NavItem, ListGroup, ListGroupItem, FormGroup, ControlLabel, Glyphicon, InputGroup } from 'react-bootstrap';
import FaxForm from './common/FaxForm';
import SendSmsForm from './common/SendSmsForm';
import AutoComplete from './common/AutoComplete';
import LoadingProgressBar from './common/LoadingProgressBar';
import { getTextValue } from './../helpers/utils';


class CaseEdit extends PureComponent {
    constructor(props) {
        super(props);
        this.save = this.save.bind(this);
        this.saveImmediate = this.saveImmediate.bind(this);
        this.close = this.close.bind(this);
        this.archive = this.archive.bind(this);
        this.archiveConfirm = this.archiveConfirm.bind(this);
        this.switchToTab = this.switchToTab.bind(this);
        this.getDashboardIntakeFields = this.getDashboardIntakeFields.bind(this);
        this.onResized = this.onResized.bind(this);
        this.state = {
            editCaseStatesOpen: false,
            editorOpen: undefined,
            emailDialogOpen: false,
            smsDialogOpen: false,
            faxDialogOpen: false,
            permanentlyDelete: false,
            dialogOpen: false,
            dialogWarning: false,
            dialogTitle: '',
            dialogSize: undefined,
            dialogText: undefined,
            dialogChildren: undefined,
            taskField: undefined,
            eventField: { EventType: 'Note' },
            loadingTask: false,
            loadingEvent: false,
            caseState: undefined,
            notes: '',
            intakeFormDialogOpen: false,
            intakeFormDialogTitle: '',
            intakeFormDialogCancel: () => {},
            emailIntakeFormDialog: false,
            smsIntakeFormDialog: false,
            paymentSettingsDialogOpen: false,
            size: undefined,
            selectedSection: 'All',
        };
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
        this.onResized();
        if (window) {
            window.addEventListener("resize", this.onResized);
        }
    }

    componentDidMount() {
        switch (this.props.editType) {
        case 'newCase':
            this.props.dispatch(caseNewAction());
            this.setState({
                intakeFormDialogOpen: true,
                intakeFormDialogTitle: 'New Case',
                intakeFormDialogCancel: () => {
                    this.close();
                    this.setState({ intakeFormDialogOpen: false });
                },
            });

            break;


        case 'editCase':
            if (isEmptyObject(this.props.currentCase) || !this.props.currentCase.id) {
                if (!this.props.loadingCurrent) {
                    this.props.dispatch(caseEditIdAction(this.props.params.id))
                        .then((result) => {
                            if (isEmptyObject(result.data)) {
                                this.props.dispatch(casesAllAction());
                                let route = filteredRoute('/case/all', this.props.cases.filter);
                                browserHistory.push(route);
                            }
                        })
                        .catch((error) => {
                            console.error(new Error().stack, error);
                            this.props.dispatch(caseSetServerError(error));
                        });
                }
            }

            break;

        default:
            break;
        }

        if (!this.props.currentConfig) {
            this.props.dispatch(userLogInLoadAction())
                .catch((error) => {
                    console.error(new Error().stack, error);
                    this.props.dispatch(caseSetServerError(error));
                });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tasks && nextProps.currentConfig && !isEmptyObject(nextProps.currentCase) && !isEmptyObject(nextProps.currentCase.intake) && !this.state.taskField) {
            let placeholderMapping = getWorkflowTranslationHashTable(nextProps.currentConfig, nextProps.currentCase, {});
            let newTask = getDefaultField(getNewId(nextProps.tasks), nextProps && nextProps.loggedIn.id);
            newTask['Title'] = transformTextFromPlaceholderMapping(newTask['Title'], placeholderMapping);
            newTask['Description'] = transformTextFromPlaceholderMapping(newTask['Description'], placeholderMapping);
            this.setState({taskField: newTask});
        }

        if (nextProps.currentCase && nextProps.currentCase.notes && nextProps.currentCase.notes['CaseState']) {
            this.setState({caseState: nextProps.currentCase.notes['CaseState']});
        }

        if (nextProps.currentCase && nextProps.currentCase.notes && nextProps.currentCase.notes['Notes'] && this.state.notes === '') {
            this.setState({notes: nextProps.currentCase.notes['Notes']});
        }
    }


    componentWillUnmount() {
        if (window) {
            window.removeEventListener("resize", this.onResized);
        }
    }

    onResized(evt) {
        let size = findBootstrapEnvironment();
        if (size === 'xs' || size === 'sm' || size === 'md') {
            size = 'xs';
        }

        this.setState({ size });
    }

    getDashboardIntakeFields() {
        const fields = getWorkflowTranslationHashTable(this.props.currentConfig,
                                                       this.props.currentCase,
                                                       {},
                                                       (type, table, field) =>
                                                                this.props.currentCase &&
                                                                this.props.currentCase.intake &&
                                                                this.props.currentCase.intake['CaseType'] === type &&
                                                                (table === undefined || (table === 'client' && !['FirstName', 'LastName', 'MiddleName', 'Phone', 'Email'].includes(field.name)) || table === 'intake') &&
                                                                (field === undefined || (table === 'intake' && this.props.currentCase.intake[field.name] && field.name !== 'AssignedTo') || (table === 'client' && this.props.currentCase.client[field.name])) &&
                                                                (field === undefined || (field.type !== 'Hidden' || field.name === 'CreatedDate')) &&
                                                                ((field === undefined && table === undefined) || !(table === 'client' && field.name === 'CreatedDate')) &&
                                                                (table === undefined || table === 'intake' || table === 'client') &&
                                                                (field === undefined || (!isEmptyString(this.props.currentCase[table][field.name]) && this.props.currentCase[table][field.name] !== '{}')) &&
                                                                (field === undefined || !field.nested),
                                                       true);

        if (!isEmptyString(this.props.currentCase['intake'] && this.props.currentCase['intake']['PublicIntakeSourceHost'])) {
            fields.unshift({
                label: 'Website Source',
                table: 'intake',
                name: 'PublicIntakeSourceHost',
                value: this.props.currentCase['intake']['PublicIntakeSourceHost'],
                placeholder: '{intake.PublicIntakeSourceHost}',
                props: {
                    label: 'Website Source',
                },
            });
        }

        this.sections = _.uniqBy(fields, v => v.section)
                         .filter(v => v.section !== undefined && v.section !== 'All')
                         .map(v => v.section);

        //this.sections.sort();
        this.sections.unshift('All');
        if (this.state.selectedSection === 'All') {
            return fields;
        }

        return fields.filter(v => v.section === this.state.selectedSection);
    }

    switchToTab(route) {
        this.setState({dialogOpen: false});
        if (this.props.route.path === 'edit') {
            let switchToRoute = `/case/edit/${route}/${this.props.currentCase.id}`;
            browserHistory.push(switchToRoute);
        }
    }

    close() {
        let route = filteredRoute('/case/all', this.props.cases.filter);
        this.props.dispatch(caseNewAction());
        this.props.dispatch(casesAllAction());
        browserHistory.push(route);
    }

    archiveConfirm() {
        let currentCase = this.props.currentCase;
        let title = 'Archive Case';
        let text = 'Do you really want to archive the current record?';
        if (!isEmptyString(currentCase['deleted_at'])) {
            title = 'Unarchive?';
            text = 'Do you want to unarchive the current record?';
        }

        let archiveConfirmFun = () => {
            this.setState({
                dialogTitle: title,
                dialogText: text,
                dialogWarning: true,
                dialogCancel: () => {this.setState({dialogOpen: false})},
                dialogConfirm: () => {
                    this.archive();
                    this.setState({dialogOpen: false});
                },
                dialogOpen: true,
                dialogSize: undefined,
                permanentlyDelete: false,
                dialogChildren: (
                    <Row>
                    <br />
                    <Col xs={12}>
                    <CheckBox field={{
                                  name: 'permanentlyDeleteCheckbox'
                              }}
                              label="Permanently delete"
                              help="If checked, the record will be permanently deleted."
                              onChange={_elem => {
                                  this.setState({permanentlyDelete: !this.state.permanentlyDelete});
                              }} />
                    </Col>
                    </Row>
                )
            });
        }

        archiveConfirmFun();
    }


    archive() {
        let currentCase = this.props.currentCase;
        let id = parseInt(currentCase.id);
        this.setState({
            loading: true
        });

        this.props.dispatch(caseDeleteAction(id, this.state.permanentlyDelete))
            .then((result) => {
                this.close();
                this.setState({
                    loading: false
                });
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
                this.setState({
                    loading: false
                })
            });
    }

    saveImmediate(data) {
        if (!isEmptyObject(validateNotesForm(data))) {
            return;
        }

        let id = parseInt(this.props.currentCase.id);
        let matter = {
            notes: data
        };

        return new Promise((resolve, reject) => {
            matterPartialFormSavePromise(this.props.dispatch, id, matter).then(result => {
                resolve(result);

            }).catch (error => {
                reject(error);
            });
        });
    }

    save(data) {
        if (this.saveTimeoutId) {
            clearTimeout(this.saveTimeoutId);
            this.saveTimeoutId = undefined;
        }

        this.saveTimeoutId = setTimeout(() => {
            this.saveTimeoutId = undefined;
            this.saveImmediate(data);
        }, 3000);
    }

    render() {
        const {
            serverError,
            submitting,
            loadingCurrent,
            currentCase = {},
            currentConfig,
            routes,
            editType,            
            tasks = [],
            loggedIn,
            employees
        } = this.props;

        const loading = loadingCurrent;
        let states = [];
        if (this.props.states) {
            states = this.props.states.map((value) => {
                const caseStateColor = getCaseStateColor(value.type, currentConfig);
                return {
                    label: (<div><Glyphicon glyph="stop" style={{ color: caseStateColor, fontSize: 20 }} /> {value.type}</div>),
                    value: value.type,
                };
            });
        }

        const intakeFields = this.getDashboardIntakeFields();
        const size = this.state.size;
        let activeRoute = routes;
        if (editType != 'newCase' && activeRoute) {
            activeRoute = routes[routes.length - 1].path;
            let slash = activeRoute.indexOf('/');
            if (slash !== -1) {
                activeRoute = activeRoute.substring(0, slash);
            }
        }

        if (!isEmptyString(currentCase['deleted_at']) && !['docs', 'notes'].includes(activeRoute)) {
            activeRoute = 'docs';
        }

        const currentCaseClient = (currentCase && currentCase['client']) || {};

        const sumCharge = (accumulator, charge) => accumulator + charge.amount;
        const sumTime = (accumulator, event) => accumulator + ((event['EventType'] === 'Time' && event.time) || 0);
        const sumTimeAmount = (accumulator, event) => accumulator + ((event['EventType'] === 'Time' && event.amount) || 0);
        const sumCost = (accumulator, event) => {
            if (event['EventType'] !== 'Cost') {
                return accumulator;
            }
            const sum = (event.items && event.items.reduce((prev, curr) => prev + (curr.amount || 0) * 100 * (curr.qty || 1), 0)) || 0; 
            return accumulator + sum;
        };
        let chargeSum = (currentCase.charges && parseInt(currentCase.charges.filter(ch => !ch['$TrustAccount$']).reduce(sumCharge, 0))) || 0;
        let chargeSumTrustAccount = (currentCase.charges && parseInt(currentCase.charges.filter(ch => !!ch['$TrustAccount$']).reduce(sumCharge, 0))) || 0;
        const chargeSumTrustAccountTransfers = (currentCase.charges && parseInt(currentCase.charges.filter(ch => !!ch['$TrustAccountTransfer$']).reduce(sumCharge, 0))) || 0;
        chargeSumTrustAccount -= chargeSumTrustAccountTransfers;
        let timeTotal = (currentCase.events && parseInt(currentCase.events.reduce(sumTime, 0))) || 0;
        const timeAmountTotal = (currentCase.events && parseInt(currentCase.events.reduce(sumTimeAmount, 0))) || 0;
        let owedTotal = (currentCase && currentCase.payment && currentCase.payment['FeeOwed']) || 0;
        owedTotal = parseFloat(owedTotal) * 100;

        let costTotal = (currentCase.events && parseInt(currentCase.events.reduce(sumCost, 0))) || 0;

        const caseStateColor = getCaseStateColor(this.state.caseState, currentConfig);
        let caseInfo = currentCase && currentCase.intake && currentCase.intake['CaseType'];
        if (currentCase && currentCase.intake && !isEmptyString(currentCase.intake['AssignedTo'])) {
            caseInfo += ` | ${getAssignedToFullName(currentCase.intake['AssignedTo'], loggedIn, employees)}`;
        }

        const billingIncrement = (currentCase && currentCase.payment && currentCase.payment['BillableMinuteIncrements']) || DEFAULT_BILLABLE_MINUTE_INCREMENTS;
        timeTotal = Math.ceil(timeTotal / billingIncrement) * billingIncrement;
        if (!isEmptyString(this.props.currentCase['deleted_at'])) {
           caseInfo += ' - ARCHIVED';
        }
 
        const owedRemaining = (Math.max((currentCase && currentCase.payment && currentCase.payment['FeeUnpaid'] || 0), 0)).toFixed(2);
        let owedStyle = {};
        if (owedRemaining > 0) {
            owedStyle = {color: requiredFormFieldColor};
        }
        let paidStyle = {};
        if (chargeSum > owedTotal) {
            paidStyle = {color: requiredFormFieldColor};
        }

        owedTotal = (owedTotal / 100.0).toFixed(2);
        chargeSum = (chargeSum / 100.0).toFixed(2);
        chargeSumTrustAccount = (chargeSumTrustAccount / 100.0).toFixed(2);
        costTotal = (costTotal / 100.0).toFixed(2);
        timeTotal = Math.round((timeTotal / 60) * 100) / 100;
        return (
            <div className="ct-casepage">
            {this.props.loadingCurrent && <Row style={{marginRight: size !== 'xs' ? 55 : 0, marginTop: -15, marginBottom: 0}}><LoadingProgressBar loading /></Row>}
                <div className="ct-pagehead">
                    <div className="ct-pagehead-main">
                        <div className="ct-pagehead-title">
                            <h1>{getFullName(currentCaseClient)}</h1>
                            <div id="tour-case-state" className="ct-statepill">
                            <Form inline>
                                <FormGroup>
                                    <InputGroup>
                                    <InputGroup.Addon>
                                        <ControlLabel>Case State<Glyphicon glyph="stop" style={{ color: caseStateColor, marginLeft: '10px', fontSize: 20 }} /></ControlLabel>
                                    </InputGroup.Addon>
                                    <AutoComplete field={{
                                                    name: 'CaseState',
                                                    value: this.state.caseState || '...',
                                                    onChange: (value) => {
                                                        if (!value || typeof(value) !== "string") {
                                                            if (value.target && value.target.value) {
                                                                value = value.target.value;
                                                            } else {
                                                                return;
                                                            }
                                                        }

                                                        this.setState({caseState: value}, () => this.save({...this.props.currentCase.notes, ...{CaseState: value, Notes: this.state.notes}}));
                                                    }
                                                }}
                                                isClearable={false}
                                                embedded
                                                disabled={loading || !isEmptyString(this.props.currentCase['deleted_at'])}
                                                options={states}
                                                style={{
                                                    maxWidth: '110%',
                                                }}
                                                loading={loading || typeof(this.props.states) === 'undefined'}
                                    />
                                    </InputGroup>
                                </FormGroup>
                            </Form>
                            </div>
                        </div>
                        <p className="ct-pagehead-sub">{caseInfo}</p>
                    </div>
                    <div className="ct-pagehead-actions">
                        <Button onClick={this.archiveConfirm}
                                disabled={submitting}
                                icon="inbox"
                                bsStyle='default'
                                className="ct-btn-ghost"
                                id="tour-case-info-archive"
                                label={!isEmptyString(this.props.currentCase['deleted_at']) ? 'Unarchive' : 'Archive'}
                                tooltip="Archive or permanently delete current record"
                                tooltipPosition="bottom"
                        />
                        <Button data-hj-whitelist
                                bsStyle='default'
                                className="ct-btn-soft"
                                onClick={() => this.setState({ paymentSettingsDialogOpen: true })}
                                label='Edit Payment'
                                icon="credit-card"
                        />
                        <Button onClick={() => {
                                      this.setState({
                                          intakeFormDialogOpen: true,
                                          intakeFormDialogTitle: 'Edit Case Details',
                                          intakeFormDialogCancel: () => {
                                              this.props.dispatch(caseEditIdAction(this.props.params.id));
                                              this.setState({ intakeFormDialogOpen: false });
                                          },
                                      });
                                  }}
                                  bsStyle='primary'
                                  data-hj-whitelist
                                  disabled={loading || !isEmptyString(this.props.currentCase['deleted_at'])}
                                  label='Edit Details'
                                  icon='cog'
                        />
                        <Button onClick={this.close}
                                disabled={submitting}
                                icon="remove"
                                label="Close"
                                id="tour-case-close"
                                tooltip="Return to viewing all records"
                                tooltipPosition="bottom"
                        />
                    </div>
                </div>
                <div className="ct-casegrid">
                    <div className="ct-casecol">
                            <Panel data-hj-whitelist id="tour-case-info" header="Client">
                                <div className="ct-contact" id="tour-case-info-client">
                                    <ClientAvatar
                                        client={currentCaseClient}
                                        size={size !== 'xs' ? 100 : 80}
                                        mobile={size === 'xs'}
                                        editable={!!(currentCaseClient && currentCaseClient.id)}
                                        deleted={!isEmptyString(this.props.currentCase['deleted_at'])}
                                    />
                                    <div className="ct-contact-text">
                                        <p className="ct-contact-name">{getFullName(currentCaseClient)}</p>
                                        <div className="ct-contact-line"><Glyphicon glyph="phone"/><span>{currentCaseClient['Phone']}</span></div>
                                        <div className="ct-contact-line"><Glyphicon glyph="envelope"/><span>{currentCaseClient['Email']}</span></div>
                                    </div>
                                </div>
                                <div className="ct-stats">
                                    <div className="ct-stat" id="tour-case-info-fee"><span className="ct-stat-label">Total fee</span><span className="ct-stat-value">${owedTotal}</span></div>
                                    <div className={`ct-stat${owedStyle.color ? ' ct-stat-danger' : ''}`} id="tour-case-info-owed"><span className="ct-stat-label">Unpaid</span><span className="ct-stat-value">${owedRemaining}</span></div>
                                    <div className={`ct-stat${paidStyle.color ? ' ct-stat-danger' : ''}`} id="tour-case-info-paid"><span className="ct-stat-label">Paid</span><span className="ct-stat-value">${chargeSum}</span></div>
                                    {chargeSumTrustAccount > 0 && <div className="ct-stat"><span className="ct-stat-label">Trust</span><span className="ct-stat-value">${chargeSumTrustAccount}</span></div>}
                                    {costTotal > 0 && <div className="ct-stat" id="tour-case-info-cost"><span className="ct-stat-label">Cost</span><span className="ct-stat-value">${costTotal}</span></div>}
                                    {timeTotal > 0 && <div className="ct-stat" id="tour-case-info-time"><span className="ct-stat-label">Time</span><span className="ct-stat-value">{timeTotal}h</span></div>}
                                </div>
                                <Row>
                                    <Col xs={12} md={9} style={{paddingLeft: 10, marginTop: 0}}>
                                    <InputGroup>
                                    <InputGroup.Addon>
                                    <Glyphicon glyph="filter" />
                                    </InputGroup.Addon>
                                    <Select field={{
                                                name: 'FieldsFilter',
                                                value: this.state.selectedSection,
                                                onChange: (value) => {
                                                    if (!value || typeof(value) !== "string") {
                                                        if (value.target && value.target.value) {
                                                            value = value.target.value;
                                                        } else {
                                                            return;
                                                        }
                                                    }

                                                    this.setState({ selectedSection: value });
                                                }
                                            }}
                                            embedded
                                            style={{ width: '100%' }}
                                            disabled={loading || !isEmptyString(this.props.currentCase['deleted_at'])}
                                            options={this.sections || []}
                                            loading={loading || this.sections === undefined}
                                    />
                                    </InputGroup>
                                    </Col>
                                </Row>
                                <Row id="tour-case-info-form" className="row-display-flex">
                                    <Col xs={12} md={6} style={{paddingLeft: 15}}>
                                        <ListGroup>
                                        {intakeFields.map((field, index) => {
                                            const value = getTextValue(field.value);
                                            return (index < intakeFields.length / 2) && (
                                                <ListGroupItem style={{border: '0px none', textOverflow: 'ellipsis', overflow: 'hidden', paddingBottom: 10, paddingTop: 5}} header={(<h6>{field.props && field.props.label}</h6>)}>{value || <span>&nbsp;</span>}</ListGroupItem>
                                            );
                                        })}
                                        </ListGroup>
                                    </Col>
                                    <Col xs={12} md={6} style={{paddingLeft: 15}}>
                                        <ListGroup>
                                        {intakeFields.map((field, index) => {
                                            const value = getTextValue(field.value);
                                            return (index >= intakeFields.length / 2) && (
                                                <ListGroupItem style={{border: "0 none", textOverflow: 'ellipsis', overflow: 'hidden', paddingBottom: 10, paddingTop: 5}} header={(<h6>{field.props && field.props.label}</h6>)}>{value || <span>&nbsp;</span>}</ListGroupItem>
                                            );
                                        })}
                                        </ListGroup>
                                    </Col>
                                </Row>
                            </Panel>
                        {isEmptyString(this.props.currentCase['deleted_at']) && (
                            <Panel id="tour-case-events" header="Events">
                                <EventStream />
                            </Panel>
                        )}
                    </div>
                    <div className="ct-casecol">
                    <div className="ct-tabs-card">
                            <Nav bsStyle="tabs"
                                activeKey={activeRoute}
                                onSelect={this.switchToTab}
                                navbar="true"
                            >

                                {isEmptyString(this.props.currentCase['deleted_at']) && <NavItem data-hj-whitelist id="tour-case-action-communication" eventKey={'intake'} disabled={submitting || loading}>Communication</NavItem>}
                                {isEmptyString(this.props.currentCase['deleted_at']) && <NavItem data-hj-whitelist id="tour-case-action-task" eventKey={'task'} disabled={submitting || loading}>Task</NavItem>}
                                {isEmptyString(this.props.currentCase['deleted_at']) && <NavItem data-hj-whitelist id="tour-case-action-event" eventKey={'event'} disabled={submitting || loading}>Event</NavItem>}
                                {isEmptyString(this.props.currentCase['deleted_at']) && <NavItem data-hj-whitelist id="tour-case-action-payment" eventKey={'payment'} disabled={submitting || loading}>Payment</NavItem>}
                                <NavItem data-hj-whitelist id="tour-case-action-documents" eventKey={'docs'} disabled={submitting || loading}>Documents</NavItem>
                                <NavItem data-hj-whitelist id="tour-case-action-scratchpad" eventKey={'notes'} disabled={submitting || loading}>Scratchpad</NavItem>
                            </Nav>
                        <div className="ct-tabpanel">
                        {activeRoute === 'intake' && (
                            <Panel data-hj-whitelist header='Send SMS, Email or Fax'>
                                    <Button bsStyle="default"
                                            style={{ width: 100 }}
                                            label="SMS ..."
                                            icon="phone"
                                            tooltip="Open SMS Dialog"
                                            id="tour-case-info-sms"
                                            onClick={() => this.setState({ smsDialogOpen: true })}
                                    />
                                    <Button bsStyle="default"
                                            style={{ width: 100, marginLeft: __IS_MOBILE__ ? 0 : '15px' }}
                                            label="Email ..."
                                            icon="envelope"
                                            tooltip="Open Email Dialog"
                                            id="tour-case-info-email"
                                            onClick={() => this.setState({ emailDialogOpen: true })}
                                    />
                                    <Button bsStyle="default"
                                            style={{ width: 100, marginLeft: __IS_MOBILE__ ? 0 : '15px' }}
                                            label="Fax ..."
                                            icon="phone-alt"
                                            tooltip="Open Fax Dialog"
                                            id="tour-case-info-fax"
                                            onClick={() => this.setState({ faxDialogOpen: true })}
                                    />
                            </Panel>
                        )}
                        {activeRoute === 'task' && (
                            <TaskEditorField initialField={this.state.taskField}
                                             disabled={loadingCurrent || this.state.loadingTask}
                                             tasks={tasks}
                                             disableMove
                                             disableCheckBox
                                             editMode
                                             useSimpleDateTime
                                             renderGoToCaseButton={false}
                                             isEmptyChronoError={false}
                                             onChange={(taskField) => {
                                                this.setState({ taskField });
                                             }}
                                             label="Add New Task"
                                             actionLabel="Add Task"
                                             caseType={currentCase && currentCase['CaseType']}
                                             currentCase={currentCase}
                                             onActionBtnClicked={(_task) => {
                                                let task = {..._task};
                                                task['$Modified$'] = true;
                                                task['CaseId'] = currentCase.id;
                                                let modifiedTasks = [task];
                                                if (!validateTaskField(modifiedTasks)) {
                                                    return;
                                                }

                                                this.setState({loadingTask: true});
                                                updateTask(
                                                    task,
                                                    this.props,                                                    
                                                    (result) => {
                                                        let placeholderMapping = getWorkflowTranslationHashTable(currentConfig, currentCase, {});
                                                        let newTask = getDefaultField(getNewId(result.data.tasks), loggedIn.id, currentCase.id);
                                                        newTask['Title'] = transformTextFromPlaceholderMapping(newTask['Title'] || '', placeholderMapping);
                                                        newTask['Description'] = transformTextFromPlaceholderMapping(newTask['Description'] || '', placeholderMapping);
                                                        this.setState({
                                                            loadingTask: false,
                                                            taskField: newTask
                                                        });
                                                    },
                                                    (error) => {
                                                        this.setState({loadingTask: false});
                                                        this.props.dispatch(caseSetServerError('Problem saving tasks!'));
                                                        console.error('Problem saving tasks!');
                                                    });
                                             }}/>
                        )}
                        {activeRoute === 'event' && (
                            <EventForm 
                                initialField={this.state.eventField}
                                onChange={(eventField) => {
                                    this.setState({eventField});
                                }}
                                label="Add New Event"
                                disabled={this.state.loadingEvent || loadingCurrent || !currentCase || !currentCase.id}
                                actionLabel="Add Event"
                                onActionBtnClicked={(_event) => {
                                    let event = validateField(_event);
                                    if (!isEmptyObject(event.error)) {
                                        this.setState({eventField: event});
                                        return;
                                    }

                                    event['CaseId'] = currentCase.id;
                                    event['$CaseId$'] = currentCase.id;
                                    if (event['EventType'] === 'Charge') {
                                        event['amount'] = Math.trunc((event['amount'] || 0) * 100);
                                    } else if (event['EventType'] === 'ChargeRefund') {
                                        event['amount'] = - Math.trunc((event['amount'] || 0) * 100);
                                        event['EventType'] = 'Charge';
                                    } else {
                                        delete event['amount'];
                                    }

                                    if (!event['EventType'] === 'Time') {
                                        delete event['time'];
                                        delete event['hourlyRate'];
                                        delete event['amount'];
                                    }

                                    if (!event['EventType'] === 'Cost') {
                                        delete event['items'];
                                    }

                                    this.setState({loadingEvent: true});
                                    this.props.dispatch(caseEditEvent(event))
                                        .then((result) => {
                                            if (event['EventType'] === 'Charge') {
                                                this.props.dispatch(caseGetChargesAction(currentCase.id))
                                                    .then((result) => {
                                                        this.setState({
                                                            loadingEvent: false,
                                                            eventField: {
                                                                EventType: event['EventType'],
                                                                EventDescription: '',
                                                                amount: '',
                                                                items: [],
                                                            }
                                                        });
                                                    }).catch((error) => {
                                                        console.error(new Error().stack, error);
                                                        this.props.dispatch(caseSetServerError(error)); 
                                                    });

                                            } else if (event['EventType'] === 'Time') {
                                                matterPartialFormSavePromise(
                                                    this.props.dispatch, 
                                                    parseInt(currentCase.id),
                                                    currentCase).then(() => {
        
                                                        this.setState({
                                                            loadingEvent: false,
                                                            eventField: {
                                                                EventType: event['EventType'],
                                                                EventDescription: '',
                                                                amount: '',
                                                                items: [],
                                                            },
                                                        });
                                                    });

                                            } else {
                                                this.setState({
                                                    loadingEvent: false,
                                                    eventField: {
                                                        EventType: event['EventType'],
                                                        EventDescription: '',
                                                        amount: '',
                                                        items: [],
                                                    }
                                                });
                                            }

                                        }).catch((error) => {
                                            console.error(new Error().stack, error);
                                            this.props.dispatch(caseSetServerError(error));
                                            this.setState({loadingEvent: false});
                                        });
                                    }}
                            />
                        )}
                        {activeRoute === 'notes' && (
                            <TextEditor field={{
                                            name: 'Notes',
                                            value: this.state.notes,
                                            onChange: (value) => {
                                                this.setState({notes: value}, () => this.save({...this.props.currentCase.notes, ...{Notes: value, CaseState: this.state.caseState}}));
                                            }
                                        }}
                                        rows={10}
                                        disabled={loadingCurrent || !isEmptyString(this.props.currentCase['deleted_at'])}
                                        loading={loadingCurrent}
                                        isEmail={false}
                            />)}
                        {activeRoute === 'payment' && (<PaymentForm owed={owedRemaining} paid={chargeSum} />)}
                        {activeRoute === 'docs' && (<Panel><TemplatesForm showDelete /></Panel>)}
                        </div>
                    </div>
                        {isEmptyString(this.props.currentCase['deleted_at']) && (
                            <Panel data-hj-whitelist id="tour-case-tasks" header="Tasks">
                                <TaskTable />
                            </Panel>
                        )}
                    </div>
                </div>
                <ServerError error={serverError} />
                <EmailDialog title="Send Email"
                             cancel={() => this.setState({ emailDialogOpen: false })}
                             open={this.state.emailDialogOpen} />
                <FaxForm showAsDialog
                         dialogCancel={() => this.setState({ faxDialogOpen: false })}
                         dialogOpen={this.state.faxDialogOpen}
                         disableCaseFilesAutoload
                />
                <SendSmsForm showAsDialog
                             templatesFieldName="notesSmsTemplates"
                             onSent={() => this.setState({ smsDialogOpen: false })}
                             cancel={() => this.setState({ smsDialogOpen: false })}
                             onSmsSent={() => this.setState({ smsDialogOpen: false })}
                             open={this.state.smsDialogOpen}
                             title="Send SMS"
                />
                <IntakeForm afterSaveAction={() => this.setState({ intakeFormDialogOpen: false })}
                            showAsDialog
                            open={this.state.intakeFormDialogOpen}
                            dialogOpen={this.state.intakeFormDialogOpen}
                            dialogTitle={this.state.intakeFormDialogTitle}
                            dialogSize="full"
                            dialogCancel={this.state.intakeFormDialogCancel}
                            dialogDedupeClient
                            isNew={this.props.editType === 'newCase'}
                />
                <ConfirmDialog title={this.state.dialogTitle}
                               warning={this.state.dialogWarning}
                               text={this.state.dialogText}
                               cancel={this.state.dialogCancel}
                               confirm={this.state.dialogConfirm}
                               open={this.state.dialogOpen}
                               size={this.state.dialogSize}
                >
                    {this.state.dialogChildren}
                </ConfirmDialog>
                <PaymentForm owed={owedRemaining}
                             paid={chargeSum}
                             showAsSettingDialog
                             dialogOpen={this.state.paymentSettingsDialogOpen}
                             dialogCancel={() => this.setState({ paymentSettingsDialogOpen: false })}
                />
            </div>
        );
    }
}

CaseEdit.propTypes = {
    fields: PropTypes.object.isRequired,
    serverError: PropTypes.string,
    submitting: PropTypes.bool.isRequired,
    loadingCurrent: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
    let loggedIn = state.user.loggedIn;
    let currentCase = state.cases.current;
    let caseType;
    if (currentCase && currentCase.intake) {
        caseType = currentCase.intake['CaseType'];
    }

    let initialValues = {...state.cases.current.notes};
    let currentConfig = state.user.config;
    let states = undefined;
    let statesType = 'caseStates';
    if (currentConfig && caseType) {
        if (currentConfig[statesType]) {
            states = currentConfig[statesType];
        }
    }

    let tasks = state.user.tasks || [];
    tasks = filterTasks(tasks, currentCase && currentCase.id, false);

    return {
        currentCase: state.cases.current,
        cases: state.cases,
        currentConfig,
        initialValues,
        states,
        caseType,
        statesType,
        isSavingNeeded: state.cases.savingNeeded,
        loadingCurrent: state.cases.loadingCurrent,
        loggedIn,
        employees: state.user.employees,
        tasks,
    };
};

export default connect(mapStateToProps)(CaseEdit);
